<template>
    <vue-select
        :id="id"
        v-model="propValue"
        v-bind:value="$attrs.value"
        :options="computedOptions"
        :multiple="multiple"
        :placeholder="placeholder"
        :preserveSearch="preserveSearch"
        :showNoOptions="!preserveSearch"
        :clearOnSelect="!preserveSearch"
        :searchable="searchable"
        :label="label"
        :track-by="trackBy ? trackBy : 'value'"
        :disabled="disabled"
        :internal-search="internalSearch"
        :class="{empty: !!!$attrs.value}"
        @remove="handleRemove"
        @search-change="handleSearchChange"
        @close="handleClose"
        @select="handleSelect"
        @open="handleOpen"
        ref="multiselect"
    >
        <template v-slot:option="props">
            <slot v-bind:option="props.option"/>
        </template>
        <template v-slot:noResult>
            <span @click="blurElem">
                К сожалению, по вашему запросу ничего не найдено
            </span>
        </template>

        <template v-slot:noOptions>
            <span>
                Список пуст
            </span>
        </template>
    </vue-select>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            searchable: {
                type: Boolean,
                default: true
            },

            placeholder: {
                type: String,
                default: ""
            },
            options: {
                type: Array,
                required: true
            },
            id: {
                default: null
            },
            preserveSearch: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: 'text'
            },
            trackBy: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            internalSearch: {
                type: Boolean,
                default: true
            },
        },
        data() {
            return {
                caretPositionStart: null,
            }
        },

        components: {
            'vue-select': Multiselect
        },
        mounted: function () {
            if (this.preserveSearch) {
                this.$refs.multiselect.search = this.$attrs.value;

                this.$refs.multiselect.$refs.tags.addEventListener('mousedown', this.handleClick, false);
                document.addEventListener('mouseup', this.onTextSelectionEnd, false);
                document.addEventListener('mousemove', this.onTextSelection, false);
            }
        },
        beforeDestroy() {
            if (this.preserveSearch) {
                this.$refs.multiselect.$refs.tags.removeEventListener('mousedown', this.handleClick, false);
                document.removeEventListener('mouseup', this.onTextSelectionEnd, false);
                document.addEventListener('test', this.onTextSelection, false);
            }
        },
        methods: {
            handleClick(e) {
                if (e.target.style.width === '100%') {
                    return;
                }

                let letterIndexAfterClick = this.getCaretPosition(e);
                this.caretPositionStart = letterIndexAfterClick;
                this.$refs.multiselect.$refs.search.setSelectionRange(letterIndexAfterClick + 1, letterIndexAfterClick + 1)
            },
            onTextSelection(e) {
                this.handleTextSelection(e);
            },
            onTextSelectionEnd(e) {
                this.handleTextSelection(e);

                this.caretPositionStart = null;
            },
            handleTextSelection(e) {
                if (this.caretPositionStart === null) {
                    return;
                }

                let letterIndexAfterClick = this.getCaretPosition(e);
                this.$refs.multiselect.$refs.search.setSelectionRange(
                    Math.min(this.caretPositionStart + 1, letterIndexAfterClick + 1),
                    Math.max(this.caretPositionStart + 1, letterIndexAfterClick + 1)
                );
            },
            handleRemove(payload) {
                this.$emit('remove', payload)
            },
            handleSelect(selectedOption,id) {
              if (this.preserveSearch) {
                this.$refs.multiselect.search = selectedOption[this.label]
              }else{
                this.$emit('select', selectedOption,id)
              }
            },
            handleSearchChange(query) {
                this.$emit('search-change', query);
            },
            blurElem() {
                if (this.preserveSearch) {
                    this.$refs.multiselect.$el.getElementsByClassName('multiselect__input')[0].blur();
                }
            },
            handleClose() {
                if (this.preserveSearch) {
                  this.$emit('input', this.$refs.multiselect.search);
                }
                this.$bus.fire('stopEditingProcess')
                this.$emit('close')
            },
            handleOpen() {
                if (this.preserveSearch) {
                    this.$emit('search-change', this.$attrs.value);
                }

                this.$bus.fire('editingProcess')
                const rect = this.$el.getBoundingClientRect()
                const visibleArea = document.body.clientWidth
                const multiselect = this.$refs.multiselect
                multiselect.$refs.list.style.display=''
                const listWidth = multiselect.$refs.list.offsetWidth
                if (visibleArea < rect.left + listWidth) {
                    multiselect.$refs.list.style.right = '0px'
                } else {
                    multiselect.$refs.list.style.right = ''
                }
                this.$emit('open');
            },
            getCaretPosition(e) {
                const element = this.$refs.multiselect.$refs.tags;

                let clickedX = e.clientX - element.getBoundingClientRect().left;
                let text = this.$refs.multiselect.$refs.search.value;
                let letters = text.split('');

                let span = document.createElement('span');
                span.classList.add('multiselect__single');
                span.style.width = 'max-content';

                let oldSpanWidth = 0;

                for (let i = 0; i < letters.length; i++) {
                    let letter = letters[i] === '' ? '&nbsp' : letters[i];
                    span.textContent = span.textContent + letter;
                    element.appendChild(span);
                    let spanWidth = span.getBoundingClientRect().width;
                    element.removeChild(span);

                    if (spanWidth > clickedX) {
                        return Math.abs(spanWidth - clickedX) <= Math.abs(oldSpanWidth - clickedX) ? i : i - 1;
                    }

                    oldSpanWidth = spanWidth;
                }

                return text.length;
            },
        },
        watch: {
            '$attrs.value' (n) {
              if(n === ''){
                this.$refs.multiselect.search = ''
              }
            }
        },
        computed: {
          computedOptions() {
            return this.options;
          },
            computedValue() {
                if (this.preserveSearch && this.$attrs.value !== '' && this.options.filter((value) => value[this.label] === this.$attrs.value).length === 0) {
                    return this.options.concat({text: this.$attrs.value, value: this.$attrs.value});
                }
                return this.options;
            },
          propValue: {
            get: function () {
              return this.computedValue.filter(({value}) => value === this.$attrs.value);
            },

            set: function (newValue) {
              if (newValue !== null) {
                this.$emit('input', newValue.value);
              }
            }
          }
        }
    }
</script>

<style lang="scss">
    .highlight {
        & .multiselect {
            &__single {
                background: #fffd03;
            }
            &__select {
                background: #fffd03 !important;
            }

            &__tags {
                background: transparent;
            }
        }
    }
    .multiselect.multiselect--active {
        & .multiselect__select {
            background: transparent !important;
        }
    }


    dialog {
        .multiselect {
            font-size: 16px !important;

            &__single {
                line-height: 21px !important;
                font-size: 16px !important;
            }

            &__input {
                font-size: 16px !important;
            }

            &__placeholder {
                font-size: 16px !important;
                color: #ccc !important;
                text-overflow: ellipsis;
                padding-left: 1px;
            }

            &--disabled {
                .multiselect__single {
                    color: #ccc !important;
                    line-height: 21px !important;
                }
            }
        }
    }

    .vuetable {
        .multiselect {
            font-size: 12px !important;

            &__single {
                font-size: 12px !important;
                height: 21px !important;
                line-height: 22px !important;
            }

            &__input {
                font-size: 12px !important;
                height: 21px !important;
            }

            &__tags {
                border: 1px solid #b0b4b4 !important;
            }
        }
        .thead .empty .multiselect__single {
           display: none;
        }
        .thead .hasError .multiselect__single {
            display: none;
        }
    }
    .multiselect.hasError {
        background-color: #fff;
    }
    .multiselect.hasError .multiselect__tags {
        border-color: #d04444 !important;
        background-color: #fd7d7d14 !important;
    }

    .table-header-cell{
        & .multiselect {
            & .multiselect__select {
                border-radius: 50%;
                background: #fff;
                margin-top: 2px !important;
                height: 18px !important;
            }

            &:hover{
                & .multiselect__select {
                    background-color: transparent !important;
                }
            }
        }
    }
    .field-select__wrap{
        & .multiselect {
            &__select{
                margin-top: 8px;
                margin-right: 8px;
            }
            &__single{
                margin: 0 0 0 10px;
            }
            &__placeholder{
                margin: 0 0 0 10px;
            }
            &__tags{
                min-height: 38px !important;
                display: flex;
                align-items: center;
                border: 1px solid #DDD9EA !important;
                border-color: #DDD9EA !important;
                border-radius: 4px !important;
            }
            &__select:before{
                content: none !important;
            }
            &__select{
                background: url(/img/chevron-right_blue_12x12.svg) center no-repeat !important;
                transform: rotate(90deg);
            }
        }

        .multiselect--active > .multiselect__select{
            transform: rotate(270deg) !important;
        }
        .multiselect.multiselect--active > .multiselect__select{
            background: url(/img/chevron-right_blue_12x12.svg) center no-repeat !important;
        }
    }

    .multiselect {
        min-height: 28px !important;
        font-size: 12px !important;

      // TODO rename style class from textarea
        &__element {
          .textarea {
            border-color: transparent !important;
            background-color: transparent !important;
          }

          &:hover .textarea {
            color: white;
          }
        }

        &--active {
            .multiselect__tags {
                background-color: rgba(255, 255, 255, 0.1) !important;
                border-color: #8b8b8b !important;
                border-width: 1px !important;
                outline: none !important;
            }
        }

        &__input {
            border: none !important;
            background: transparent !important;
            height: 22px !important;
            padding-left: 1px !important;
            padding-right: 18px !important;
        }

        &__tags {
            height: 23px !important;
            min-height: 23px !important;
            padding: 0 !important;
            border-radius: 3px !important;
            border: 1px solid #b0b4b4;
            position: relative;
        }

        &__select {
            width: 18px !important;
            height: 22px !important;
            z-index: 10 !important;
            padding: 0 !important;
            top: 0 !important;

            &::before {
                border-color: #000 transparent transparent !important;
                opacity: 0.5 !important;
            }
        }

        &__single {
            font-weight: normal;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #000 !important;
            padding-left: 1px !important;
            padding-right: 5px !important;
        }

        &__placeholder {
            padding-bottom: 2px !important;
            padding-top: 0 !important;
            text-overflow: ellipsis;
        }

        &__option {
            min-height: auto !important;
            padding: 2px 5px 2px 5px !important;
            font-weight: normal !important;

            &:after {
                display: none;
            }

            &--highlight {
                background: #1c91FF !important;
            }
        }

        &__content-wrapper {
            min-width: fit-content !important;
            z-index: 999999 !important;
        }

        &--disabled {
            background: none !important;
        }
    }


    .multiselect.large {
        width: auto !important;
        height: 34px !important;
        margin-bottom: 5px;

        &:not(.network-clinics-select) .multiselect__option {
            padding: 8px 5px !important;
        }

        & .multiselect__input{
            margin: 0;
            height: 34px !important;

            color: #000 !important;
            font-size: 24px !important;
            font-weight: bold !important;
            padding-right: 18px !important;
        }

        & .multiselect__select{
            height: 30px !important;
            z-index: 9999;
            /*background-color: white;*/
            margin: 2px;
        }
        & .multiselect__tags{
            height: 34px !important;
            margin-bottom: 5px;
            display: flex;
        }

        & .multiselect__single{
            margin: 0 !important;
            line-height: 32px !important;

            color: #000 !important;
            font-size: 24px !important;
            font-weight: bold !important;

            padding-left: 5px !important;
            padding-right: 18px;
            padding-top: 1px;
            padding-bottom: 0;
            letter-spacing: 0.1px;
        }

        & .multiselect__element{
            color: #000 !important;
            font-size: 24px !important;

            font-weight: normal;
            display: block;
            white-space-collapse: collapse;
            text-wrap: nowrap;
            min-height: 1.2em;
            padding: 0px 2px 1px;
        }


        & select {
            width: auto !important;
            height: 34px !important;
        }


    }
</style>
